import { createContext, useContext } from 'react'

/**
 * The cost password's context, kept apart from the provider component so both
 * files stay fast-refresh eligible -- the same reason `budget/format.js` sits
 * beside its components rather than inside one.
 */
export const CostLock = createContext(null)

export function useCostLock() {
  const ctx = useContext(CostLock)
  if (!ctx) throw new Error('useCostLock must be used inside CostLockProvider')
  return ctx
}
